import { Outlet } from 'react-router-dom'
import { useRouter } from '~/hooks/useRouter'
import { Menu } from '~/components/Menu/Menu'
import { FloatingMessenger } from '~/components/FloatingMessenger/FloatingMessenger'

export default function Layout() {
  const { asPath } = useRouter()

  const isMainPage =
    asPath === '/' ||
    asPath === '/ro' ||
    asPath === '/ru' ||
    asPath.startsWith('/?') ||
    asPath.startsWith('/ro?') ||
    asPath.startsWith('/ru?')

  return (
    <>
      <meta
        name="keywords"
        content="Dulap Studio, dulap personalizat Chișinău, mobilier la comandă Moldova, dulap la comandă, mobilă la comandă Chișinău, мебель на заказ Кишинев, тумбочка кишинев, тумба, комод кишинев, тумба молдова, комод Молдова, мебель на заказ Молдова"
      />

      <div className="layout">
        <Menu />
        <main className={`main ${isMainPage ? '' : 'mainOffset'}`}>
          <Outlet />
        </main>
        {/* <Footer /> is rendered eagerly in main.tsx (AppShell), AFTER the
            prerender-safe <SeoContentSection>, so the crawlable product/SEO
            content lands before the footer in the DOM. */}
        <FloatingMessenger />
      </div>
    </>
  )
}